// browserTimeZone returns only an IANA time-zone identifier. The server owns
// the reference instant; the browser provides the user's wall-clock zone.
export function browserTimeZone(): string | undefined {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone?.trim();
    return timeZone || undefined;
  } catch {
    return undefined;
  }
}
